/* Cart – bundler */
import { mount as mountQty }       from './qtyAjax.js';
import { mount as mountBridge }    from './crossSellBridge.js';
import { mount as mountBulkAdd }   from './crossSellBulkAdd.js';

function mountAll() {
  mountQty?.();
  mountBridge?.();
  mountBulkAdd?.();
}

export function mount() {
  mountAll();

  if (window.jQuery) {
    const $doc = window.jQuery(document.body);
    $doc.on('updated_wc_div cart_page_refreshed wc_fragment_refresh', () => {
      mountAll();
    });
  }
}
